<template>
  <div class="tableProfile" v-loading.fullscreen.lock="loading">
    <el-button type="primary" @click="goSupport" size="small">设置页</el-button>
    <div style="margin-top: 10px">
      <el-table
        size="mini"
        :data="profileList"
        border
        element-loading-text="加载中"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column label="id" prop="id" width="250">
          <template #default="scope">
            <span class="ellipsis" :class="{ special: scope.row.type }">
              {{ scope.row.id }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="name" prop="name">
          <template #default="scope">
            <span class="ellipsis" :class="{ special: scope.row.type }">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="描述" prop="description">
          <template #default="scope">
            <span class="ellipsis" :class="{ special: scope.row.type }">
              {{ scope.row.description }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="配置内容">
          <template #default="scope">
            <span class="ellipsis" :class="{ special: scope.row.type }">
              {{ scope.row.body }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button
              v-if="!scope.row.type"
              @click="add(scope.row.id)"
              type="primary"
              size="mini"
              >使用</el-button
            >
            <el-button v-else type="info" size="mini"
              >使用中</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
    import { postTableProfile,getZoneTableProfile } from "@/api/zone.js";
    import { TableProfile } from "@/api/support";
export default {
  data() {
    return {
      loading: true,
      profileList: [],
      profile: "",
    };
  },
  created() {
    this.initial();
  },
        mounted() {
  },
        methods: {
    add(id) {
      this.loading = true;
      postTableProfile({
          profileId: id,
        })
        .then((res) => {
          if (res.status == 0) {
            this.$message.success("成功");
            this.initial();
          }else if (res.status == 1){
            this.$message.error(res.phrase);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    goSupport() {
      this.$router.push({ name: "tableProfile" });
    },
    initial() {
      TableProfile()
        .then((res) => {
          if (res.status == 0) {
            this.profileList = res.profiles;
            this.init();
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    init() {
      getZoneTableProfile()
        .then((res) => {
          if (res.status == 0) {
            this.profileList.forEach((ele) => {
              if (ele.id == res.profiileId) {
                console.log(ele)
                ele.type = true;
              }
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.tableProfile {
  width: 100%;
  padding: 50px;
}

.ellipsis {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.special {
  color: red;
}
</style>
